// Centralized API path constants for Umbraco endpoints
export const COMMENTS_API = '/umbraco/api/Comments';
export const GRID_API = '/umbraco/api/Grid';

// Add other shared api paths here as needed in future
